<template>
  <div>
    <v-layout>
      <v-flex xs12>
        <v-toolbar dark color="info">
          <v-toolbar-title>{{ $t('Pdf-Settings') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn
            color="info"
            dark
            @click="Kaydet"
            :loading="loading"
            :disabled="notesTooLong"
          >
            {{ $t('save_button') }}
          </v-btn>
        </v-toolbar>
      </v-flex>
    </v-layout>

    <v-container fluid>
      <v-layout row wrap>

        <v-flex xs12 md8 pa-1>
          <v-card>
            <v-card-title class="subheading">
              {{ $t('PDF-Notes') }}
            </v-card-title>

            <v-alert
              v-if="notesTooLong"
              type="warning"
              dense
              outlined
              class="ma-3"
            >
              {{ $t('Notes-Limit-Exceeded') }}
            </v-alert>

            <v-card-text>
              <v-textarea
                v-model="PdfAyar.TrNotes"
                :label="$t('Turkish-Notes')"
                prepend-inner-icon="mdi-note-text-outline"
                auto-grow
                rows="2"
                clearable
                :counter="NOTE_LIMIT"
                outlined
                dense
                class="mb-3"
              />

              <v-textarea
                v-model="PdfAyar.EnNotes"
                :label="$t('English-Notes')"
                prepend-inner-icon="mdi-translate"
                auto-grow
                rows="2"
                clearable
                :counter="NOTE_LIMIT"
                outlined
                dense
                class="mb-3"
              />

              <v-textarea
                v-model="PdfAyar.DeNotes"
                :label="$t('German-Notes')"
                prepend-inner-icon="mdi-translate"
                auto-grow
                rows="2"
                clearable
                :counter="NOTE_LIMIT"
                outlined
                dense
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md4 pa-1>
          <v-card>
            <v-card-title class="subheading">
              PDF Logo
            </v-card-title>

            <v-card-text class="pt-2">
              <div class="grey--text text--darken-1">
                {{ $t('You-can-upload-the-logo-to-be-used-in-PDF-outputs-from-here.') }}
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="blue lighten-5"
                class="blue--text"
                block
                @click="LogoYukle"
              >
                {{ $t('Upload-Logo-For-Pdf') }}
                <v-icon right>mdi-upload</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
       

        
          <v-card>
            <v-card-title class="subheading">
              PDF Banner
            </v-card-title>

            <v-card-text class="pt-2">
              <div class="grey--text text--darken-1">
                {{ $t('You-can-upload-the-banner-to-be-used-in-PDF-outputs-from-here.') }}
              </div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="blue lighten-5"
                class="blue--text"
                block
                @click="BannerYukle"
              >
                {{ $t('Upload-Banner-For-Pdf') }}
                <v-icon right>mdi-upload</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
         </v-flex>

      </v-layout>

      <imagefiledialog ref="imagefiledialog" />

      <v-snackbar v-model="snackbar" :timeout="6000" top right>
        {{ mesaj }}
        <v-btn flat color="pink" @click="snackbar=false">{{ $t('Close') }}</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import auth from '../../../api/auth'
import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";

export default {
  components: { imagefiledialog },
  data() {
    return {
      loading: false,
      snackbar: false,
      mesaj: "",
      NOTE_LIMIT: 4000,
      PdfAyar: {
        tutarGoster: true,
        TrNotes: "",
        EnNotes: "",
        DeNotes: ""
      }
    }
  },
  mounted(){
this.Yukle()
  },

  computed: {
    notesTooLong() {
      const tr = (this.PdfAyar.TrNotes || "").length
      const en = (this.PdfAyar.EnNotes || "").length
      const de = (this.PdfAyar.DeNotes || "").length
      return tr > this.NOTE_LIMIT || en > this.NOTE_LIMIT || de > this.NOTE_LIMIT
    }
  },

  methods: {
Yukle () {
  const credentials = JSON.parse(window.localStorage.getItem('credentials'))

  const params = { CompanyCode: credentials.SirketKodu }  

  this.$http.post(
    auth.API_URL + 'api/TicketParametre/TicketParametreGet',
    params,
    {
      headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
    }
  ).then((res) => {
    const p = res.data || {}
    const diger = ((p.GenelParametre || {}).ParametreDiger) || {}

    this.PdfAyar.TrNotes = diger.TrNotes || ""
    this.PdfAyar.EnNotes = diger.EnNotes || ""
    this.PdfAyar.DeNotes = diger.DeNotes || ""
  })
},

    LogoYukle() {
      this.$refs.imagefiledialog.open("PDF Logo Yükle", "PdfLogo")
        .then((onay) => {
          if (onay) {
            this.mesaj = "Logo başarıyla yüklendi."
            this.snackbar = true
          }
        })
        .catch(() => {
          this.mesaj = "Logo yüklenemedi."
          this.snackbar = true
        })
    },

    BannerYukle() {
  this.$refs.imagefiledialog.open("PDF Banner Yükle", "PdfLogo2")
    .then((onay) => {
      if (onay) {
        this.mesaj = "Banner başarıyla yüklendi."
        this.snackbar = true
      }
    })
    .catch(() => {
      this.mesaj = "Banner yüklenemedi."
      this.snackbar = true
    })
},

    Kaydet() {
      if (this.notesTooLong) {
        this.mesaj = this.$t('Notes-Limit-Exceeded')
        this.snackbar = true
        return
      }

      this.loading = true

      const credentials = JSON.parse(window.localStorage.getItem('credentials'))
      const params = {
        SirketKodu: credentials.SirketKodu,
        GenelParametre: {
          ParametreDiger: {
            TrNotes: this.PdfAyar.TrNotes,
            EnNotes: this.PdfAyar.EnNotes,
            DeNotes: this.PdfAyar.DeNotes
          }
        }
      }

      this.$http.post(auth.API_URL + 'api/TicketParametre/TicketParametreAdd', params, {
        headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() }
      }).then(() => {
        this.mesaj = "PDF ayarları kaydedildi."
        this.snackbar = true
        this.loading = false
      }, () => {
        this.mesaj = "Service Unavailable"
        this.snackbar = true
        this.loading = false
      })
    }
  }
}
</script>
